import {Link} from 'react-router-dom'

const About = () => {
    return (
        <div>
            <Link to='/Task-Tracker/'> Go Back </Link>
            <h4>This application is a project management tool that allows you to keep track of your tasks.</h4>
        </div>
    )
}

export default About
